
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDyQd8pkZLbFivXqV8joQNffFfwudOIM1w",
  authDomain: "bonjour-cffca.firebaseapp.com",
  projectId: "bonjour-cffca",
  storageBucket: "bonjour-cffca.appspot.com",
  messagingSenderId: "528617872805",
  appId: "1:528617872805:web:cc0e32b0e900e85cf29c4c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const db = getFirestore(app);

// Enable offline persistence when supported
try {
  enableIndexedDbPersistence(db)
    .catch((err) => {
      if (err.code === 'failed-precondition') {
        // Multiple tabs open, persistence can only be enabled in one tab at a time
        console.log('Persistence failed: Multiple tabs open');
      } else if (err.code === 'unimplemented') {
        // The current browser does not support all of the features required
        console.log('Persistence is not available in this browser');
      }
    });
} catch (e) {
  console.error('Error enabling persistence:', e);
}

// Updated Firestore security rules:
/*
rules_version = '2';
service cloud.firestore {
  match /databases/{database}/documents {
    // Check if the user is an admin
    function isAdmin() {
      return request.auth != null && 
             exists(/databases/$(database)/documents/userProfiles/$(request.auth.uid)) &&
             get(/databases/$(database)/documents/userProfiles/$(request.auth.uid)).data.admin == true;
    }
    
    // Allow access to user profiles
    match /userProfiles/{userId} {
      allow read, write: if request.auth != null && request.auth.uid == userId;
    }
    
    // Lesson rules - allow admins to manage all lessons
    match /lessons/{lessonId} {
      // Regular users can only read their own lessons
      allow read: if request.auth != null && (
                     resource.data.userId == request.auth.uid || 
                     isAdmin()
                   );
      // Regular users can create their own lessons
      allow create: if request.auth != null && (
                       request.resource.data.userId == request.auth.uid || 
                       isAdmin()
                     );
      // Allow admins to update and delete any lesson
      allow update, delete: if request.auth != null && (
                               resource.data.userId == request.auth.uid || 
                               isAdmin()
                             );
    }
    
    // Allow users to read and create their own activity logs
    match /activityLogs/{logId} {
      allow read: if request.auth != null && 
                   request.query.limit <= 50 && 
                   request.query.where[0].field_path == "userId" &&
                   request.query.where[0].op == "==" &&
                   request.query.where[0].value == request.auth.uid;
      allow create: if request.auth != null && request.resource.data.userId == request.auth.uid;
    }
  }
}
*/

export { auth, db, googleProvider };
